module.exports = __webpack_public_path__ + "static/media/kale3.9194bebf.webp";